import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from "@angular/core";

@Component({
    selector: "ts-card-grid",
    templateUrl: "./ts-summary-grid.component.html",
    standalone: false
})
export class TsSummaryGridComponent implements OnInit, OnChanges {
    @Input() tsSummary: any;
    @Input() buAccess: any;

    test: any = [1, 2, 3, 4, 5];

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "tsSummary") {
                this.tsSummary = null;
                this.tsSummary = changes["tsSummary"]["currentValue"];
            }
            if (propName === "buAccess") {
                this.buAccess = changes["buAccess"]["currentValue"];
            }
        }
    }

    ngOnInit() {}
}
